import React from 'react';
import Image from 'next/image';
import { truncateText } from '../../utils/utilFunctions';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

import Link from 'next/link';
function LastArticlesLarge(props) {
 return (
  <Link
   href={{
    pathname: `${process.env.NEXT_PUBLIC_origin}/articles/${props.data.articleUrl}`,
   }}
   className='buttonsStyle bg-white/50 w-full flex items-center justify-center text-backbg   lg:max-w-7xl md:max-w-3xl  lg:px-8 g-red-500 px-6 md:px-10'
  >
   <div className=' gap-6 flex flex-col  items-center md:items-start justify-start py-4 g-blue-500  md:px-0'>
    <div className='flex items-center justify-center flex-col  w-full  h-[300px] bg-gray-500 '>
     <Image width={500} height={500} alt={props.data.articleUrl} src={props.data.images} className='     object-cover w-full h-full    ' />
    </div>
    <div className='text-backbg/70 text-hp8 text-start w-full flex items-start flex-col justify-start gap-6 lg:px-4'>
     <div className='w-full flex flex-row items-center justify-start text-xs text-backbg/50'>
      <p className='capitalize'>{props.data.tags[0]}</p>
      <span className='w-6 h-[1px] mx-2 border border-1 border-black/30'></span>
      <p className='capitalize'>
       {format(new Date(props.data.updatedAt), 'MMM d, yyyy', {
        locale: fr,
       })}
      </p>
     </div>
     <p className='text-xl'>{props.data.title}</p>
     <p className='text-sm text-backbg/60'>{truncateText(props.data.resume, 200)}</p>
     <p className='text-xs text-backbg/50'>Lire l&apos;article...</p>
    </div>
   </div>
  </Link>
 );
}

export default LastArticlesLarge;
